window.initAssessmentFormTabs = function(openTab=undefined){
  let fieldset_with_errors = $('fieldset[data-form-part]:first').data('form-part');

  if(openTab.length){
    fieldset_with_errors = openTab;
  }

  if($('.error-message').length){
    fieldset_with_errors = $('.error-message:first').closest('fieldset[data-form-part]').data('form-part');
  }

  $('fieldset[data-form-part]').addClass('is-hidden');
  $(`fieldset[data-form-part="${fieldset_with_errors}"]`).removeClass('is-hidden');

  $('a[data-form-part]').removeClass('is-active');
  $(`a[data-form-part="${fieldset_with_errors}"]`).addClass('is-active');

  $('a[data-form-part]').on('click', function(e){
    e.preventDefault();
    goToAssessmentFormFieldset($(this).data('form-part'));
  })
}

window.goToAssessmentFormFieldset = function(part){
	$('a[data-form-part]').removeClass('is-active');
    $(`a[data-form-part="${part}"]`).addClass('is-active');
    $('fieldset[data-form-part]').addClass('is-hidden');
    $(`fieldset[data-form-part="${part}"]`).removeClass('is-hidden');
}

window.goToNextAssessmentFormFieldset = function(){
	let current_index = $('a[data-form-part].is-active').index('a[data-form-part]');
	let next_part = $(`a[data-form-part]:eq(${current_index + 1})`).data('form-part');
	goToAssessmentFormFieldset(next_part);
}

window.goToPreviousAssessmentFormFieldset = function(){
	let current_index = $('a[data-form-part].is-active').index('a[data-form-part]');
	let next_part = $(`a[data-form-part]:eq(${current_index - 1})`).data('form-part');
	if(current_index > 0){
		goToAssessmentFormFieldset(next_part);
	}
}